<template>
  <div class="con3_h5">
    <div class="con3_box">
      <div class="con3_tab">
        <div class="title" @click="tabShow = 0">{{ tabs[0].title }}</div>
        <div class="title" @click="tabShow = 1">{{ tabs[1].title }}</div>
      </div>
      <div :class="`line active_line${tabShow}`"></div>

      <div v-for="(tab, tabIndex) in tabs" :key="tabIndex" v-show="tabShow === tabIndex">
        <div class="box_list umt_p3">
          <div class="list_child br-1" :style="{ backgroundImage: `url(${tab.items[0].img})` }">
            <div class="bt_title">{{ tab.items[0].text }}</div>
          </div>
          <div class="list_child uml_p1 br-2" :style="{ backgroundImage: `url(${tab.items[1].img})` }">
            <div class="bt_title">{{ tab.items[1].text }}</div>
          </div>
        </div>

        <div class="box_list umt_p1">
          <div class="list_child br-3" :style="{ backgroundImage: `url(${tab.items[2].img})` }">
            <div class="bt_title br_p15_3">{{ tab.items[2].text }}</div>
          </div>
          <div class="list_child uml_p1 br-4" :style="{ backgroundImage: `url(${tab.items[3].img})` }">
            <div class="bt_title br_p15_4">{{ tab.items[3].text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  /*
  实例: 目前只支持显示数组的前两项, 切每项仅显示前四个item
  [
    {
      title: 'xxx',
      items: [
        { text: 'xxx', img: 'xxx' },
        { text: 'xxx', img: 'xxx' },
        { text: 'xxx', img: 'xxx' },
        { text: 'xxx', img: 'xxx' },
      ]
    },
    {
      title: 'xxx',
      items: [
        { text: 'xxx', img: 'xxx' },
        { text: 'xxx', img: 'xxx' },
        { text: 'xxx', img: 'xxx' },
        { text: 'xxx', img: 'xxx' },
      ]
    }
  ]
   */
  props: {
    tabs: Array,
  },
  data() {
    return {
      tabShow: 0,
    }
  },
}
</script>

<style lang="less" scoped>
.con3_h5 {
  padding: 0.3rem 0.15rem;
}

.con3_box {
  color: #333;
  font-size: 0.28rem;

  .con3_tab {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d3d3d3;
    // padding: 0 0.48rem;

    .title {
      padding-bottom: 15px;
      width: 50%;
      text-align: center;
    }
  }

  .line {
    width: 2.9rem;
    height: 0.04rem;
    background: #e61717;
    margin-top: -0.03rem;
  }

  .active_line0 {
    margin-left: 0.43rem;
  }

  .active_line1 {
    margin-left: 55%;
  }

  .umt_p3 {
    margin-top: 0.3rem;
  }

  .umt_p1 {
    margin-top: 0.1rem;
  }

  .box_list {
    width: 100%;
    border-radius: 15px;
    display: flex;
    justify-content: space-evenly;

    .list_child {
      width: 3.4rem;
      height: 2.79rem;
      background-size: cover;
      background-repeat: no-repeat;
      position: relative;

      .bt_title {
        width: 3.4rem;
        height: 0.72rem;
        background: rgba(51, 51, 51, 0.9);
        font-size: 0.26rem;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #fff;
        line-height: 0.72rem;
        position: absolute;
        bottom: 0;
        text-align: center;
      }

      .br_p15_3 {
        border-radius: 0 0 0 0.15rem;
      }

      .br_p15_4 {
        border-radius: 0 0 0.15rem;
      }
    }

    .uml_p1 {
      margin-left: 0.1rem;
    }

    .br-1 {
      border-radius: 0.15rem 0 0;
    }

    .br-2 {
      border-radius: 0 0.15rem 0 0;
    }

    .br-3 {
      border-radius: 0 0 0 0.15rem;
    }

    .br-4 {
      border-radius: 0 0 0.15rem;
    }
  }
}
</style>
